import moment from 'moment'

const formatDate = (value: Date) => {
  if (value !== null) {
    return moment(value).format('MMM-DD-YYYY')
  } else {
    return 'N/A'
  }
}
const formatPhone = (phone: string) => {
  if (phone) {
    return phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
  }
}

export {formatDate, formatPhone}
